import React, { FC, memo, useEffect, useState } from 'react';
import styles from './CookieBar.module.scss';
import { CloseOutlined } from '@ant-design/icons';
import Cookies from 'js-cookie';
import classNames from 'classnames';
import { shallowEqual, useSelector } from 'react-redux';
import { AppState } from '@/store';
import { handleRichText } from '@/utils/handleRichText';
import dayjs from 'dayjs';

type Props = {
  className?: string;
  cookiesBar: {
    footer: {
      cookie_bar: {
        cookie_text: string;
        button_label: string;
      };
    }[];
  };
};

const CookiesBar: FC<Props> = memo(props => {
  const { cookiesBar } = props;
  const [agreeUseCookie, setAgreeUseCookie] = useState<boolean>(true);

  const handleClose = () => {
    const currentTime = new Date().getTime();
    const currentTimeString = dayjs(currentTime).format('YYYY-MM-DDTHH:mm:ssZ').toString();
    localStorage.setItem('agreeUseCookie', 'true');
    localStorage.setItem('agreeUseCookieTime', currentTimeString);
    setAgreeUseCookie(true);

    window?.dataLayer?.push({
      event: 'buttonClick',
      buttonTitle: 'cookies_bar',
      pageURL: window.location.href,
      componentName: 'cookies bar'
    });
  };

  useEffect(() => {
    setAgreeUseCookie(false);
    const agreeUseCookieData = localStorage.getItem('agreeUseCookie');
    const agreeUseCookieTimeData = localStorage.getItem('agreeUseCookieTime');
    const agreeUseCookieTime = dayjs(agreeUseCookieTimeData).valueOf().toString();
    if (agreeUseCookieData && agreeUseCookieTime) {
      const currentTime = new Date().getTime();
      const expirationTime = 24 * 60 * 60 * 1000;
      if (currentTime - parseInt(agreeUseCookieTime, 10) > expirationTime) {
        localStorage.removeItem('agreeUseCookie');
        localStorage.removeItem('agreeUseCookieTime');
        setAgreeUseCookie(false);
      } else {
        setAgreeUseCookie(true);
      }
    }
  }, []);

  const footer = cookiesBar.footer || [];
  const cookieBar = footer[0]?.cookie_bar || {};
  const cookiesTextData = cookieBar.cookie_text || '';

  const handleCookieText = (cookieText: string) => {
    return cookieText.replace(/\\/g, '');
  };

  return (
    <>
      {cookiesTextData.trim() ? (
        <div
          className={classNames(styles.Cookies_Bar, { [styles.Hide_Cookie_Bar]: agreeUseCookie })}
        >
          <div
            className={'Cookie_Rich_Text'}
            dangerouslySetInnerHTML={{
              __html: handleRichText(handleCookieText(cookiesTextData))
            }}
          ></div>
          <CloseOutlined style={{ color: '#fff' }} onClick={() => handleClose()} />
        </div>
      ) : (
        ''
      )}
    </>
  );
});

export default CookiesBar;
